
import { useContext, useEffect, useState } from 'react';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import './agence.css';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { addAgence, getAgences, updateAgence } from '../../context/agenceContext/apiCalls';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import { useParams, useNavigate } from 'react-router-dom';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { wilayas, communes } from '../../data.js';
import FilterInput from '../../components/filterInput/FilterInput.jsx';
import ModalComponent from '../../components/modalComponent/ModalComponent.jsx';
import FormInput from '../../components/formInput/FormInput.jsx';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent.jsx';

function Agence() {
  const { agences, dispatch, isFetching, error, agence, isFetchingAdd, errorAdd, isFetchingUpdate, errorUpdate, count: pages } = useContext(AgenceContext);
  const [wilaya, setWilaya] = useState(wilayas[0]);
  const [commune, setCommune] = useState(communes[0][0]);
  const [nom, setNom] = useState("");

  const { page = 1 } = useParams();
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const listItems = [10, 20, 30, 40, 50, 100];

  useEffect(() => {
    getAgences(dispatch, pageSize, page, wilaya.id, commune.id, nom);
  }, [dispatch, page, pageSize, wilaya, commune, nom])

  useEffect(() => {
    setCommune(communes[wilaya.id][0]);
  }, [wilaya])

  useEffect(() => {
    navigate(`/agences/1`);
  }, [wilaya, commune, nom])



  /**************  Ajouter Modal  **************/
  const [modalAddActive, setModalAddActive] = useState(false);
  const [addNom, setAddNom] = useState("");
  const [addErrorBox, setAddErrorBox] = useState("");
  const [addWilaya, setAddWilaya] = useState(wilayas[0]);
  const [addCommune, setAddCommune] = useState(communes[0][0]);

  useEffect(() => {
    setAddCommune(communes[addWilaya.id][0]);
  }, [addWilaya])

  useEffect(() => {
    getAgences(dispatch, pageSize, page, wilaya.id, commune.id, nom);
  }, [agence])

  const handleAddAgence = () => {
    if (addNom.trim() == "") {
      setAddErrorBox('Vous devez compléter le Nom');
      return;
    }
    if (addWilaya.id === 0) {
      setAddErrorBox('Vous devez compléter la Wilaya');
      return;
    }
    if (addCommune.id === 0) {
      setAddErrorBox('Vous devez compléter la Commune');
      return;
    }
    addAgence(dispatch, addNom, addWilaya.id, addCommune.id);
    setAddNom('');
    setAddWilaya(wilayas[0]);
    setAddCommune(communes[0][0]);
    setModalAddActive(false)
  }

  /**************  End Ajouter Modal  **************/


  /**************  Update Modal  **************/
  const [modalUpdateActive, setModalUpdateActive] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [updateNom, setUpdateNom] = useState("");
  const [updateErrorBox, setUpdateErrorBox] = useState("");
  const [updateWilaya, setUpdateWilaya] = useState(wilayas[0]);
  const [updateCommune, setUpdateCommune] = useState(communes[0][0]);

  const updateModalUpdateActive = (id, nom, wilayaa, communee) => {
    setModalUpdateActive(true);
    setUpdateId(id);
    setUpdateNom(nom);
    setUpdateWilaya(wilayas.filter(item => item.id == wilayaa)[0]);
    setUpdateCommune(communes[wilayaa].filter(item => item.id == communee)[0]);
  }

  const handleUpdateAgence = () => {
    if (updateNom.trim() == "") {
      setUpdateErrorBox('Vous devez compléter le Nom');
      return;
    }
    if (updateWilaya.id === 0) {
      setUpdateErrorBox('Vous devez compléter la Wilaya');
      return;
    }
    if (updateCommune.id === 0) {
      setUpdateErrorBox('Vous devez compléter la Commune');
      return;
    }
    updateAgence(dispatch, updateId, updateNom, updateWilaya.id, updateCommune.id);
    setUpdateId('')
    setUpdateNom('');
    setUpdateWilaya(wilayas[0]);
    setUpdateCommune(communes[0][0]);
    setModalUpdateActive(false)
  }

  /**************  End Update Modal  **************/


  // console.log(`Nom : ${addNom},  Add Wilaya : ${addWilaya.nom}  , Add Commune : ${addCommune.nom}`);
  // console.log(`Id : ${updateId}, Nom : ${updateNom},  Update Wilaya : ${updateWilaya.nom}  , Update Commune : ${updateCommune.nom}`);
  // console.log(agences);
  // console.log(agence);


  return (
    <div className='container-global'>
      <AdminSideBar activeTab="agence" />
      <div className='center'>
        <div className="title">
          <span className="material-symbols-rounded">shoppingmode</span>
          <span>Agences</span>
        </div>
        {
          error ? <ErrorComponent error={error} /> : (
            <>
              <div className="filter">
                <span className="adv-research">Recherche Avancée</span>
                <div className="filter-content">
                  <DropDownComponent data={wilayas} itemChoisir={wilaya} setItemChoisir={setWilaya} filter />
                  <DropDownComponent data={communes[wilaya.id]} itemChoisir={commune} setItemChoisir={setCommune} filter />
                  <FilterInput placeholder={"Nom"} setItem={setNom} />
                </div>
              </div>

              <div className="add-item">
                <span className='color-1' onClick={() => setModalAddActive(true)}>Ajouter</span>
              </div>

              {
                isFetching ? <LoadingComponent /> : (
                  agences.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                    : (
                      <>
                        <PageSizeComponent listItems={listItems} pageSize={pageSize} setPageSize={setPageSize} itemLocation='agences' />
                        <div className="content">
                          {
                            <>
                              <TableComponent headers={['Id', 'Nom', 'Wilaya', 'Commune', 'Date', 'Action']}>
                                {
                                  agences.map((agence, index) => (
                                    <tr key={index}>
                                      <td>{agence.id}</td>
                                      <td>{agence.nom}</td>
                                      <td>{wilayas.filter(item => item.id == agence.wilaya)[0]['nom']}</td>
                                      <td>{communes[agence.wilaya].filter(item => item.id == agence.commune)[0]['nom']}</td>
                                      <td>{agence.createdAt.slice(0, 10)}</td>
                                      <td>
                                        <span onClick={() => updateModalUpdateActive(agence.id, agence.nom, agence.wilaya, agence.commune)} className='update'>Modifier</span>
                                      </td>
                                    </tr>
                                  ))
                                }
                              </TableComponent>
                              {
                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='agences' />)
                              }
                            </>
                          }
                        </div>
                      </>
                    )
                )
              }
            </>
          )
        }

      </div>




      {/*  Modal Components */}
      {
        <>
          <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Ajouter Agence">
            {
              errorAdd ? setAddErrorBox(errorAdd) : (
                isFetchingAdd ? <SubLoadingComponent /> : (
                  <form>
                    {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                    <FormInput label='Nom' itemInput={addNom} setItemInput={setAddNom} />
                    <DropDownComponent data={wilayas} itemChoisir={addWilaya} setItemChoisir={setAddWilaya} />
                    <DropDownComponent data={communes[addWilaya.id]} itemChoisir={addCommune} setItemChoisir={setAddCommune} />
                    <div className='button' onClick={handleAddAgence}>
                      <span>Valider</span>
                    </div>
                  </form>
                )
              )
            }
          </ModalComponent>

          <ModalComponent modalActive={modalUpdateActive} setModalActive={setModalUpdateActive} setErrorBox={setUpdateErrorBox} title="Update Agence">
            {
              errorUpdate ? setUpdateErrorBox(errorUpdate) : (
                isFetchingUpdate ? <SubLoadingComponent /> : (
                  <form>
                    {updateErrorBox !== "" && (<div className='box-error'>{updateErrorBox}</div>)}
                    <FormInput label='Nom' itemInput={updateNom} setItemInput={setUpdateNom} />
                    <DropDownComponent data={wilayas} itemChoisir={updateWilaya} setItemChoisir={setUpdateWilaya} />
                    <DropDownComponent data={communes[updateWilaya.id]} itemChoisir={updateCommune} setItemChoisir={setUpdateCommune} />
                    <div className='button' onClick={handleUpdateAgence}>
                      <span>Valider</span>
                    </div>
                  </form>
                )
              )
            }
          </ModalComponent>
        </>
      }
      {/*  End Modal Components */}


    </div>
  )
}
export default Agence